module.exports = __webpack_public_path__ + "assets/underline.fae80140.svg";